export class DropdownUniqueName {

    static readonly SimpleCompanyDropdown = new DropdownUniqueName("companies");

    private constructor(public readonly uniqueName: string) {
    }

    static readonly companyDropdowns = [DropdownUniqueName.SimpleCompanyDropdown];
}